import { Checkbox } from '@chakra-ui/react'

export default Checkbox
